// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"128a7b21","285":"be4f839f","356":"f6664007","470":"fe485ea7","534":"d0ef41b1","787":"28cb0dcd","884":"617aa9ad"}[chunkId] + ".chunk.js";
};